<div class="pop" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <div class="content">
    <div *ngIf="extra.product.has_image" class="img">
      <img class="ya_image" [src]="extra.product.image_path">
    </div>
    <div *ngIf="!extra.product.has_image" class="noimg">
      <h2>{{extra.title}}</h2>
    </div>
    <div class="extra-content">
      <header>
        <h2>{{extra.title}}</h2>
        <div class="selection__info">
          <ng-container *ngIf="choicesInExtra() > 0; then ChoicesLeft else NoChoicesLeft"></ng-container>
          <ng-template #NoChoicesLeft>
            <span langkey="dialog_maximum_extras_reached"></span>
          </ng-template>
          <ng-template #ChoicesLeft>
            <span langkey="dialog_still_selectable"></span>
            <span class="selectable-count">{{choicesInExtra()}}</span>
          </ng-template>
        </div>
      </header>
      <ng-container *ngIf="hasDesription(extra.product.details.description)">
        <p [truncatedText]="extra.product.details.description"></p>
      </ng-container>
    </div>
    <sot-scroller-vertical>
      <div class="sub-extra__list">
        <ng-container *ngFor="let sub of extra.sub_items">
          <div class="sub-extra__item"
            (click)="fadeOutExtraBySelectedTag(sub)?openResetExtraTagFilter(sub): onDishClick($event, extragroup, extra, sub)"
            [class.not-avail]="(!isSubExtraAvailable(sub) || fadeOutExtraBySelectedTag(sub))"
            [class.active]="!fadeOutExtraBySelectedTag(sub) && isExtraSelected(extragroup, extra,sub)">
            <ng-container *ngIf="displaySettingsImg && sub.product.has_image">
              <img class="ya_image sub-img" [src]="sub.product.image_path">
            </ng-container>
            <ng-container *ngIf="!displaySettingsImg || !sub.product.has_image"><img class="noimg-sub"></ng-container>
            <div class="sub-extra-content">
              <div class="sub-extra-content--top">
                <header>
                  <h2>{{sub.title}}</h2>
                  <ng-container *ngIf="displayAdditionalInformation(sub.product)">
                    <div class="info-content">
                      <a class="btn"
                        (click)="showSubExtraProductInfo(sub.product,sub.title); $event.stopPropagation()"><span>i</span></a>
                    </div>
                  </ng-container>
                </header>
                <ng-container *ngIf="hasDesription(sub.product.details.description)">
                  <p [truncatedText]="sub.product.details.description"></p>
                </ng-container>
              </div>
              <ng-container *ngIf="isItemTagEnabled">
                <div class="sub-extra-tag">
                  <div class="tag" *ngFor="let extra_tag of GetExtraProductTagsByIds(sub.product.product_tag_ids)"
                    id="extraProductTag{{extra_tag.id}}">
                    <div class="tag-svg" [innerHTML]="extra_tag.svg_html"></div>
                  </div>
                </div>
              </ng-container>
              <!--Extra: Base price & Deposit-->
              <ng-container *ngIf="(use_eCommerce && showBasePrice(sub.product))|| sub.has_deposit ">
                <div class="product-content_info">
                  <ng-container *ngIf="showBasePrice(sub.product)">
                    <div class="product-baseUnit">
                      <span
                        *ngIf="extraBaseUnit(sub.product) === baseUnit.PIECE">{{(extraPricePerUnit(sub.product)|price
                        )+
                        " /1" }}<span langkey="details_baseunit_piece"></span></span>
                      <span
                        *ngIf="extraBaseUnit(sub.product) === baseUnit.LITER">{{(extraPricePerUnit(sub.product)|price
                        )+
                        " /1" }}
                        <span langkey="details_baseunit_liter"></span></span>
                      <span *ngIf="extraBaseUnit(sub.product)=== baseUnit.KILO">{{(extraPricePerUnit(sub.product)|price
                        )+
                        " /1" }}<span langkey="details_baseunit_kilo"></span></span>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="sub.has_deposit">
                    <div class="deposit">
                      <span [langkey]="deposit_langkey"></span>
                      <span class="info-value">{{sub.deposit | price:"p c" }} </span>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
              <footer class="priceandamount">
                <div class="preis">{{itemViewPrice() + sub.price |
                  price:"+p c" }}</div>
                <ng-container *ngIf="extragroup.max_choices === 1;then singleSelection else multipleSelection">
                </ng-container>
                <ng-template #singleSelection>
                  <a class="btn insert"
                    [class.active]="!fadeOutExtraBySelectedTag(sub)&& isExtraSelected(extragroup, extra, sub)">
                    <div inlineSVG="sot/sot-icon.svg#sot-done" flex [setSVGAttributes]="{class: 'icon'}"></div>
                  </a>
                </ng-template>
                <ng-template #multipleSelection>
                  <sot-amount [amount]="getCount(extragroup, extra, sub)"
                    [max]="getCount(extragroup, extra, sub) + choicesInExtra()"
                    (amountChange)="setExtraCountTo($event, extragroup, extra, sub)"></sot-amount>
                </ng-template>
              </footer>
              <div *ngIf="!isSubExtraAvailable(sub)" class="not-available">
                <ng-container
                  *ngIf="sub.product && !sub.product.schedule.active && sub.product.schedule.hint; then ScheduleHintTemplate else NotAvailableHintTemplate"></ng-container>
                <ng-template #ScheduleHintTemplate>
                  <span>{{sub.product.schedule.hint}}</span>
                </ng-template>
                <ng-template #NotAvailableHintTemplate>
                  <span langkey="details_not_available"></span>
                </ng-template>
              </div>
              <div *ngIf="isSubExtraAvailable(sub) && fadeOutExtraBySelectedTag(sub)" class="not-available">
                <span langkey="tags_article_labeling_text"></span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </sot-scroller-vertical>
  </div>
  <footer class="buttons">
    <a class="btn back" (click)="Close()" langkey="button_continue"> <span langkey="button_continue">
        <div inlineSVG="sot/sot-icon.svg#sot-backward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
      </span>
    </a>
  </footer>
</div>